import React, { useEffect } from 'react';

import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { CalendarSettings } from 'screens/oneOnOneRabbit/SettingsPage/features/CalendarSettings/CalendarSettings';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

const CompanyOneOnOneCalender = () => {
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'Me-settings-calendar',
      },
    });
  }, []);
  return (
    <>
      <PlainTextHeader mb={1}>Calendar</PlainTextHeader>
      <CalendarSettings />
    </>
  );
};

export default CompanyOneOnOneCalender;
